// extracted by mini-css-extract-plugin
export default {"input":"Checkbox_input__Lni9l","label":"Checkbox_label__vVG5c"};